/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { observer } from 'mobx-react'
import { PageBgStyle, TitleWrap } from '@styles/base.style'
import { useOnUnmount, useOnMount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'
import TelegramGuideButton from '@components/Button/TelegramGuideButton'
import MessageArrivalButton from '@components/Button/MessageArrivalButton'
// import EventFloatingButton from '@views/Matchup/EventFloatingButton'
import AdvCasinoBannerButton from '@components/Button/AdvCasinoBannerButton'
import ComponentBetSlip from '@views/Popup/ComponentBetSlip'
import { isMobile } from 'react-device-detect'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import { BackBtn } from '@styles/button.style'
import Chat from '@views/Popup/Chat'
import BettingHistoryBg from '@assets/images/bg/betting-history-bg.png'
import NavBar from '@views/Navbar'
import BettingHistoryTab from './BettingHistoryTab'
import { appScrollTo, loadOrReload } from '@utils/utils'
import RankingPopupButton from '@views/Popup/RankingPopup/Button'

const BettingHistory: React.FC = () => {
  const {
    bettingHistoryStore, authStore, routerStore,
    chattingStore, userStore, logStore,
  } = useRootStore()
  const { isChatEnabled } = chattingStore
  const [updator, setUpdator] = useState(0)

  const update = () => {
    setUpdator(updator + 1)
  }

  useOnMount(() => {
    if (!authStore.isSignedIn) {
      loadOrReload('/')
    }
    bettingHistoryStore.setUpdator(update)

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  useOnUnmount(() => {
    bettingHistoryStore.cleanup()
  })

  let advCasinoBannerBtnClass: string
  let telegramExistenceClass: string

  if (isMobile) {
    advCasinoBannerBtnClass = 'betting-history-banner'
  } else {
    advCasinoBannerBtnClass = 'betting-history-banner pc-betting-history-banner'
  }

  if (userStore.isRegisteredTelegram() === true) {
    telegramExistenceClass = 'no-telegram'
  }

  return (
    <Fragment>
      <div css={PageBgStyle} className="betting-history-bg">
        <img src={BettingHistoryBg} alt="야구선수 배경"/>
      </div>
      {isMobile && (
        <TitleWrap className="title-wrap no-bg">
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'c010', buttonId: '002' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}
      {/*<EventFloatingButton/>*/}
      <AdvCasinoBannerButton className={`${advCasinoBannerBtnClass} ${telegramExistenceClass}`}/>
      {userStore.isRegisteredTelegram() === false && <TelegramGuideButton/>}
      <BettingHistoryTab/>
      <MessageArrivalButton key="BettingHistory:MessageArrivalButton"/>
      {!isMobile && <ComponentBetSlip/>}
      {isChatEnabled && !authStore.isSpecificClubMember && isMobile && <Chat key="BettingHistory:Chat"/>}
      {/*TODO: 랭킹 현황을 볼 수 있는 팝업*/}
      <RankingPopupButton/>
      {isMobile && <NavBar key="BettingHistory:NavBar"/>}
    </Fragment>
  )
}

export default observer(BettingHistory)
